import { MouseEvent, useState } from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { IconButton } from '@vk-hr-tek/ui/IconButton';
import { Icon } from '@vk-hr-tek/ui/Icon';
import { Counter } from '@vk-hr-tek/ui/Counter';

import { useDispatch, useSelector } from '@app/hooks';

import {
  selectBellNotificationsStatus,
  selectBellNotificationsWithDateGroups,
  getBellNotifications,
  selectBellCounter,
} from '../../../slice';
import { BellMenu } from '../../../segments/BellMenu';

const MAX_BELL_NOTIFICATIONS = 99;

import { Header } from './Header';
import { Body } from './Body';
import { Footer } from './Footer';

export const Bell = () => {
  const dispatch = useDispatch();
  const status = useSelector(selectBellNotificationsStatus);
  const items = useSelector(selectBellNotificationsWithDateGroups);
  const counter = useSelector(selectBellCounter);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    dispatch(getBellNotifications({ isRead: false, limit: 15 }));
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const isMenuOpen = Boolean(anchorEl);
  const menuId = 'bell-notification-menu';

  return (
    <Box display="flex" alignItems="center">
      <Box display="inline" position="relative" onClick={handleMenuOpen}>
        {!!counter && (
          <Box
            position="absolute"
            left={21}
            top={2}
            zIndex={1}
            cursor="pointer"
          >
            <Counter
              backgroundColor="red"
              color="white"
              counter={counter > MAX_BELL_NOTIFICATIONS ? '99+' : counter}
              size="extraSmall"
            />
          </Box>
        )}
        <IconButton
          testId="test-id-bell-notifications-trigger"
          onClick={handleMenuOpen}
        >
          <Icon
            name={
              counter ? 'notification_subtract_outline' : 'notification_outline'
            }
            size="24"
            color="original.brand.primary"
          />
        </IconButton>
      </Box>

      {isMenuOpen && (
        <BellMenu
          anchorEl={anchorEl}
          id={menuId}
          open={isMenuOpen}
          onClose={handleMenuClose}
        >
          <Box display="flex" flexDirection="column">
            <Header />
            <Body onClose={handleMenuClose} />
            {(items.length > 0 || status === 'loading') && (
              <Footer onClose={handleMenuClose} />
            )}
          </Box>
        </BellMenu>
      )}
    </Box>
  );
};
